import { configureStore } from '@reduxjs/toolkit';
import authReducer from './slices/authSlice';
import dashboardReducer from './slices/dashboardSlice';
import leadReducer from './slices/leadSlice';
import customerReducer from './slices/customerSlice';
import salesReducer from './slices/salesSlice';
import inventoryReducer from './slices/inventorySlice';
import marketingReducer from './slices/marketingSlice';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    dashboard: dashboardReducer,
    leads: leadReducer,
    customers: customerReducer,
    sales: salesReducer,
    inventory: inventoryReducer,
    marketing: marketingReducer,
  },
});